import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Card, CardBody, Col, Container, Row, Button } from 'reactstrap';
import { reduxForm } from 'redux-form';
import { withTranslation } from 'react-i18next';
import validate from './validate';
import Modal from '../../../shared/components/Modal';
import history from '../../../history';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Radio from '@material-ui/core/Radio';
import TextField from '@material-ui/core/TextField';
import FormLabel from '@material-ui/core/FormLabel';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import ContactThirdParty from './ContactThirdParty';
import { Nav, NavItem, NavLink, TabContent, TabPane } from 'reactstrap';
import classnames from 'classnames';
import DataReactTableContact from './DataReactTableContact';
import Spinner from 'react-bootstrap/Spinner';
import { withStyles } from "@material-ui/core/styles";
import Checkbox from '@material-ui/core/Checkbox';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';

const renderField = ({
    input, placeholder, type, meta: { touched, error },
}) => (
    <div className="form__form-group-input-wrap form__form-group-input-wrap--error-above">
        <input {...input} placeholder={placeholder} type={type} />
        {touched && error && <span className="form__form-group-error">{error}</span>}
    </div>
);


const MedicalCheckbox = withStyles({
    root: {
        '&$checked': {
            color: '#4ce1b6',
        },
    },
    checked: {},
})((props) => <Checkbox color="default" {...props} />);

renderField.propTypes = {
    input: PropTypes.shape().isRequired,
    placeholder: PropTypes.string,
    type: PropTypes.string,
    meta: PropTypes.shape({
        touched: PropTypes.bool,
        error: PropTypes.string,
    }),
};

renderField.defaultProps = {
    placeholder: '',
    meta: null,
    type: 'text',
};


class ThirdPartyUpdate extends Component {
    constructor() {
        super();
        this.state = {
            nit: '',
            name: '',
            regime: '',
            id: '',
            clientGroup: '',
            country:  '',
            department: '',
            id_city: '',
            city: '',
            address: '',
            email: '',
            webSite: '',
            sgss: '',
            resolution: '',
            telephone: '',
            days: 0,
            particular: null,
            history: null,
            errors: {},
            toucheds: {},
            openAlert: false,
            color: '',
            departments: [],
            cities: [],
            countries:[],
            loadData: false,
            error: false,
            tipo: 1,
            observaciones: '',
            activeTab: "1",
            nameContatc: '',
            lastNameContact: '',
            positionConstact: '',
            emailContact: '',
            telephoneContact: '',
            nvoContacto: false,
            isLoading: true,
            contactos: [],
            discountCard: false,
            responsabilityType: null,
            tributaryResponsability: null,
            taxpayerType: null,
            isPropsFromLocation: false,
            automaticReceiptInZero: false,
            invoiceNote: ''
        };
    }

    componentDidMount() {
        var id_departamento = null;
        if (this.props.hasOwnProperty('location')) {
            this.setState({ isPropsFromLocation: true });
            if (this.props.location?.hasOwnProperty('state')) {
                id_departamento = this.props.location.state.user?.direccion.id_departamento;
            }
        } else {
            id_departamento = this.props.user.direccion.id_departamento;
        }
        this.loadThird(this.props);
        this.setState({ loadData: true }, () => {
            this.loadDepartment().then((departments) => {
                /*this.setState({ departments: departments }, () => { */
                    this.loadCountries().then((countries) => {
                        this.setState({countries: countries})
                    });
                //})
            })
        })
    }

    loadThird = (props) => {
        if (props.hasOwnProperty('location')) {
            if (props.location?.hasOwnProperty('state')) {
                if (props.location.state.update) {
                    this.setState({
                        nit: props.location.state.user?.nit,
                        name: props.location.state.user?.nombre,
                        telephone: props.location.state.user?.telefono,
                        regime: props.location.state.user?.regimen,
                        clientGroup: props.location.state.user?.grupocliente,
                        id_city: props.location.state.user?.direccion !== null ? props.location.state.user?.direccion.id_ciudad : '',
                        city: props.location.state.user?.direccion !== null ? props.location.state.user?.direccion.ciudad : '',
                        country: props.location.state.user?.direccion !== null ? props.location.state.user?.direccion.id_pais : '',
                        department: props.location.state.user?.direccion !== null ? props.location.state.user?.direccion.id_departamento : '',
                        address: props.location.state.user?.direccion !== null ? props.location.state.user?.direccion.direccion : '',
                        email: props.location.state.user?.correo,
                        webSite: props.location.state.user?.paginaweb,
                        sgss: props.location.state.user?.codigosgsss,
                        resolution: props.location.state.user?.resolucionss,
                        days: props.location.state.user?.diasvencimiento,
                        particular: props.location.state.user?.clienteparticular,
                        history: props.location.state.user?.copiahistoriac,
                        id: props.location.state.user?.id_tercero,
                        tipo: props.location.state.user?.tipo,
                        observaciones: props.location.state.user?.observacion,
                        responsabilityType: props.location.state.user?.tipo_responsabilidad,
                        tributaryResponsability: props.location.state.user?.responsabilidad_tributaria,
                        taxpayerType: props.location.state.user?.tipo_contribuyente,
                        automaticReceiptInZero: props.location.state.user?.recibos_cero_admitir,
                        discountCard: props.location.state.user?.tarjeta_descuento,
                        invoiceNote: props.location.state.user?.nota_factura
                    }
                    
                    );
                }
            }
        } else {
            if (props.update) {
                this.setState({
                    nit: props.user?.nit,
                    name: props.user?.nombre,
                    telephone: props.user?.telefono,
                    regime: props.user?.regimen,
                    clientGroup: props.user?.grupocliente,
                    id_city: props.user?.direccion !== null ? props.user?.direccion.id_ciudad : '',
                    city: props.user?.direccion !== null ? props.user?.direccion.ciudad : '',
                    country: props.user?.direccion !== null ? props.user?.direccion.id_pais : '',
                    department: props.user?.direccion !== null ? props.user?.direccion.id_departamento : '',
                    address: props.user?.direccion !== null ? props.user?.direccion.direccion : '',
                    email: props.user?.correo,
                    webSite: props.user?.paginaweb,
                    sgss: props.user?.codigosgsss,
                    resolution: props.user?.resolucionss,
                    days: props.user?.diasvencimiento,
                    particular: props.user?.clienteparticular,
                    history: props.user?.copiahistoriac,
                    id: props.user?.id_tercero,
                    tipo: props.user?.tipo,
                    observaciones: props.user?.observacion,
                    responsabilityType: props.user?.tipo_responsabilidad,
                    tributaryResponsability: props.user?.responsabilidad_tributaria,
                    taxpayerType: props.user?.tipo_contribuyente,
                    automaticReceiptInZero: props.user?.recibos_cero_admitir,
                    discountCard: props.user?.tarjeta_descuento,
                    invoiceNote: props.user?.nota_factura
                });
            }
        }
    }

    maskNIT = (valor) => {
        var cadena = "";
        if (valor.match(/^(([0-9]|(-{1})){0,13})$/) && valor.length <= 13) {
            cadena = valor;
        } else if (valor.length > 13) {
            cadena = this.state.nit;
        } else {
            cadena = this.state.nit;
        }

        console.log("cadena:" + cadena);
        return cadena;
    }

    handleNit = (value) => {
        //console.log(value);
        var nit = this.maskNIT(value);
        //console.log(nit);
        this.setState({ nit: nit });
    }

    handleName = (value) => {
        this.setState({ name: value.toUpperCase() });

    }

    handleRegime = (value) => {
        this.setState({ regime: value });

    }

    handleClientGroup = (value) => {
        this.setState({ clientGroup: value });
    }

    handleCountry = (e) => {
        this.setState({ country: e, departments:[], city:[], cities:[] }, ()=>{
            this.loadDepartment(e).then((departamentos) => {
                this.setState({ departments: departamentos});
            });
        });
    
    }

    handleDepartment = (e) => {
        this.setState({ department: e, city: [] }, () => {
            this.loadCities(e).then((cities) => {
                this.setState({ cities: cities });
            });
        });
    }

    handleCity = (e) => {
        this.setState({ city: e, id_city: e });
    }

    handleAddress = (value) => {
        this.setState({ address: value });
    }

    handleEmail = (value) => {
        this.setState({ email: value });
    }

    handleWebSite = (value) => {
        this.setState({ webSite: value });
    }

    handleSGSS = (value) => {
        this.setState({ sgss: value });
    }

    handleResolution = (value) => {
        this.setState({ resolution: value });
    }

    handleDaysDeadLine = (value) => {
        this.setState({ days: value });
    }

    handleParticular = (value) => {
        this.setState({ particular: value });

    }

    handleHistory = (value) => {
        this.setState({ history: value });
    }

    handleChangeTipo = (value) => {
        this.setState({ tipo: value });
    }

    handlerObservaciones = (value) => {
        this.setState({ observaciones: value })
    };

    handlerNameContact = (value) => {
        this.setState({ nameContatc: value });
    };

    handlerLastNameContact = (value) => {
        this.setState({ lastNameContact: value })
    }

    handlerPositionContact = (value) => {
        this.setState({ positionConstact: value });
    };

    handlerEmailContact = (value) => {
        this.setState({ emailContact: value })
    }

    handlerTelephoneContact = (value) => {
        this.setState({ telephoneContact: value });
    };

    handlerNvoContacto = (value) => {
        this.setState({ nvoContacto: value })
    };


    toggle = (tab) => {
        if (this.state.activeTab !== tab) {
            this.setState({ activeTab: tab });
        };
    };

    handleReset = () => {
        console.log(this.state.nit);
        this.setState({
            nit: '',
            name: '',
            regime: '',
            clientGroup: '',
            country: '',
            department: '',
            id_dpto: '',
            address: '',
            email: '',
            webSite: '',
            sgss: '',
            resolution: '',
            days: 0,
            particular: null,
            history: null,
            errors: {},
            toucheds: {},
            openAlert: false,
            color: '',
            observaciones: ''
        });
    }

    handlerinvoiceNote = (invoiceNote) => {
        this.setState({ invoiceNote });
    }

    validateData = (data, value) => {
        var errors = validate({ [data]: value }, this.state.discountCard);
        console.log("error:0 " + JSON.stringify(errors));
        var errorNew = this.state.errors;
        errorNew[data] = errors[data];
        this.setState({ errors: errorNew });
    }

    updateThird = async () => {
        var dataVal = {
            nit: this.state.nit,
            name: this.state.name,
            regime: this.state.regime,
            clientGroup: this.state.clientGroup,
            country: this.state.country,
            department: this.state.department,
            city: this.state.id_city,
            address: this.state.address,
            email: this.state.email,
            telefono: this.state.telephone,
            website: this.state.webSite,
            sgss: this.state.sgss,
            resolution: this.state.resolution,
            days: this.state.days,
            particular: this.state.particular,
            history: this.state.history,
            tipo: this.state.tipo
        }

        var errors = validate(dataVal, this.state.discountCard);
        this.setState({ errors: errors });
        console.log(JSON.stringify(errors));
        if (Object.entries(errors).length === 0) {
            var dataSend = {
                nit: this.state.nit,
                id_tercero: this.state.id,
                telefono: this.state.telephone,
                nombre: this.state.name,
                regimen: this.state.regime,
                grupodecliente: this.state.clientGroup,
                pais: this.state.country,
                direccion:
                {
                    id_pais: this.state.country,
                    id_dpto: this.state.department,
                    id_ciudad: this.state.id_city,
                    direccion: this.state.address
                },
                correo: this.state.email,
                paginaweb: this.state.webSite,
                codigosgsss: this.state.sgss,
                resolucionss: this.state.resolution,
                diasvencimiento: this.state.days,
                clienteparticular: this.state.particular,
                copiahistoriac: this.state.history,
                tipo: this.state.tipo,
                observacion: this.state.observaciones,
                tarjeta_descuento: this.state.discountCard,
                tipo_responsabilidad: this.state.responsabilityType,
                responsabilidad_tributaria: this.state.tributaryResponsability,
                tipo_contribuyente: this.state.taxpayerType,
                recibos_cero_admitir: this.state.automaticReceiptInZero,
                nota_factura: this.state.invoiceNote
            }

            try {
                var response = await fetch(process.env.REACT_APP_PUBLIC_URL + 'tercero/update', {
                    method: 'PUT',
                    headers: {
                        'Content-Type': 'application/json',
                        'authorization': 'Bearer ' + sessionStorage.getItem('token'),
                    },
                    body: JSON.stringify(dataSend)
                });

                var result = await response.text();
                console.log(result);
                this.setState({ error: false, openAlert: true, color: "success", title: "Exitoso!", message: 'Cliente actualizado con exito' });
                return true;
            } catch (e) {
                console.log(e);
                this.setState({ error: true, openAlert: true, color: "danger", title: "Error!", message: 'Error actualizando Cliente' });
                return false;
            }
        } else {
            this.setState({ error: true, openAlert: true, color: "danger", title: "Error!", message: "ingresa datos validos al formulario" });
        }
    }

    createThird = async () => {
        var dataVal = {
            nit: this.state.nit,
            name: this.state.name,
            regime: this.state.regime,
            clientGroup: this.state.clientGroup,
            country: this.state.country,
            city: this.state.id_city,
            department: this.state.department,
            address: this.state.address,
            email: this.state.email,
            telefono: this.state.telephone,
            website: this.state.webSite,
            sgss: this.state.sgss,
            resolution: this.state.resolution,
            days: this.state.days,
            particular: this.state.particular,
            history: this.state.history,
            tipo: this.state.tipo
        }
        var errors = validate(dataVal, this.state.discountCard);
        this.setState({ errors: errors });
        console.log(JSON.stringify(errors));
        if (Object.entries(errors).length === 0) {
            console.log("Check OK!!");
            var dataSend = {
                nit: this.state.nit,
                nombre: this.state.name,
                regimen: this.state.regime,
                telefono: this.state.telephone,
                grupodecliente: this.state.clientGroup,
                direccion:
                {
                    id_pais: this.state.country,
                    id_dpto: this.state.department,
                    id_ciudad: this.state.city,
                    direccion: this.state.address
                },
                correo: this.state.email,
                paginaweb: this.state.webSite,
                codigosgsss: this.state.sgss,
                resolucionss: this.state.resolution,
                diasvencimiento: this.state.days,
                clienteparticular: this.state.particular,
                copiahistoriac: this.state.history,
                tipo: this.state.tipo,
                observacion: this.state.observaciones,
                tarjeta_descuento: this.state.discountCard,
                tipo_responsabilidad: this.state.responsabilityType,
                responsabilidad_tributaria: this.state.tributaryResponsability,
                tipo_contribuyente: this.state.taxpayerType,
                recibos_cero_admitir: this.state.automaticReceiptInZero,
                nota_factura: this.state.invoiceNote
            }


            await fetch(process.env.REACT_APP_PUBLIC_URL + 'tercero/create', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'authorization': 'Bearer ' + sessionStorage.getItem('token'),
                },
                body: JSON.stringify(dataSend)
            }).then(response => {
                if (response.status != 500 && response.status != 403) {
                    return response.json();
                }
                else {
                    throw new Error(`Error creando el cliente`);
                }
            }).then(data => {
                this.setState({ error: false, openAlert: true, color: "success", title: "Exitoso!", message: "Cliente creado correctamente" });
            }).catch((error) => {
                console.error('Error:', error);
                this.setState({ error: true, openAlert: true, color: "error", title: "Error!", message: "Ha ocurrido un error creando el cliente" });
            });
        } else {
            console.log("QUE PASO???")
            this.setState({ error: true, openAlert: true, color: "danger", message: "Ingresa datos validos al Formulario" });
        }
    }

    loadDepartment = (paicod) => {
        return new Promise((resolve, reject) => {
            const getURL = paicod? `departamentos/listar?id_pais=${paicod}` : `departamentos/listar`
            fetch(process.env.REACT_APP_PUBLIC_URL + getURL, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'authorization': 'Bearer ' + sessionStorage.getItem('token'),
                }
            })
                .then(response => {
                    return response.json();
                })
                .then(data => {
                    resolve(data);
                })
                .catch((error) => {
                    console.error('Error:', error);
                    resolve(error);
                });
        })

    }

    loadCountries = () => {
        return new Promise((resolve, reject) => {
            fetch(process.env.REACT_APP_PUBLIC_URL + 'paises/listar', {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'authorization': 'Bearer ' + sessionStorage.getItem('token'),
                }
            })
                .then(response => {
                    return response.json();
                })
                .then(data => {
                    resolve(data);
                })
                .catch((error) => {
                    console.error('Error:', error);
                    resolve(error);
                });
        })
    }

    loadCities = (depcod) => {
        var data = { id_dpto: depcod };
        return new Promise((resolve, reject) => {
            fetch(process.env.REACT_APP_PUBLIC_URL + 'ciudades/listar', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'authorization': 'Bearer ' + sessionStorage.getItem('token'),
                },
                body: JSON.stringify(data)
            })
                .then(response => {
                    return response.json();
                })
                .then(data => {
                    resolve(data);
                })
                .catch((error) => {
                    console.error('Error:', error);
                    resolve(error);
                });
        })
    }

    handleChangeDiscountCard = (_discountCard) => {
        this.setState({ discountCard: _discountCard });
    }

    handlerAutoReceiptsZero = (_autoReceiptsZero) => {
        this.setState({ automaticReceiptInZero: _autoReceiptsZero });
    }

    handlerResponsabilityType = (value) => {
        this.setState({ responsabilityType: value });
    }

    handlerTributaryResponsability = (value) => {
        this.setState({ tributaryResponsability: value });
    }

    handlerTaxpayerType = (value) => {
        this.setState({ taxpayerType: value });
    }

    render() {
        return (
            <Container >
                <Row>
                    <Col md={12}>
                        <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', margin: '0em 2em' }}>
                            {this.state.isPropsFromLocation ?
                                <div>
                                    <Tooltip
                                        title="Regresar a la lista de Clientes"
                                        style={{ padding: '2px', backgroundColor: '#55e5bb' }}
                                    >
                                        <IconButton
                                            aria-label="upload picture"
                                            component="span"
                                            className='tooltip-top'
                                            onClick={() => {
                                                history.push({
                                                    pathname: process.env.PUBLIC_URL + '/config/terceros/listar'
                                                });
                                            }}
                                        >
                                            <ArrowBackIcon style={{ color: '#153365' }} />
                                        </IconButton>
                                    </Tooltip>
                                </div>
                                : null}
                            <div className="title-general-section-icon-arrow-back">
                                <h3>Cliente</h3>
                            </div>
                        </div>
                    </Col>
                    <Col md={12} lg={12}>
                        <Card>
                            <CardBody>

                                <form className="material-form" >

                                    <Row>
                                        <Col md={3}>
                                            <TextField
                                                required
                                                id="document-number-standard-required"
                                                label="Nit"
                                                type="text"
                                                className="material-form__field"
                                                style={{ marginLeft: 20 }}
                                                value={this.state.nit}
                                                placeholder='123456789-9'
                                                onChange={(e) => this.handleNit(e.target.value)}
                                                error={this.state.errors.hasOwnProperty("nit") ? this.state.errors.nit !== "" : false}
                                                helperText={this.state.errors.nit}
                                                InputLabelProps={{
                                                    style: { color: '#646777' },
                                                    shrink: true
                                                }}
                                            />
                                        </Col>
                                        <Col md={3}>
                                            <TextField
                                                required
                                                id="first-name-standard-required"
                                                label="Nombre"
                                                className="material-form__field"
                                                style={{ marginLeft: 20 }}
                                                type="text"
                                                value={this.state.name}
                                                onChange={(e) => this.handleName(e.target.value)}
                                                error={this.state.errors.hasOwnProperty("name") ? this.state.errors.name !== "" : false}
                                                helperText={this.state.errors.name}
                                                InputLabelProps={{
                                                    style: { color: '#646777' },
                                                    shrink: true
                                                }}
                                            />
                                        </Col>
                                        <Col md={3}>
                                            <TextField
                                                required
                                                id="first-telephone-standard-required"
                                                label="Telefono"
                                                className="material-form__field"
                                                style={{ marginLeft: 20 }}
                                                type="tel"
                                                value={this.state.telephone}
                                                onChange={(e) => this.setState({ telephone: e.target.value })}
                                                error={this.state.errors.hasOwnProperty("telefono") ? this.state.errors.telefono !== "" : false}
                                                helperText={this.state.errors.telefono}
                                                InputLabelProps={{
                                                    style: { color: '#646777' },
                                                    shrink: true
                                                }}
                                            />
                                        </Col>
                                    </Row>


                                    {/* <TextField
                                                                className="material-form__field"
                                                                label="Grupo Cliente"
                                                                id="id-simplegp-select"
                                                                style={{ width: '25%', marginLeft: 20 }}
                                                                select
                                                                value={this.state.clientGroup}
                                                                onChange={(event) => {
                                                                    this.handleClientGroup(event.target.value);
                                                                }}
                                                                error={this.state.errors.hasOwnProperty("clientGroup") ? this.state.errors.clientGroup !== "" : false}
                                                                helperText={this.state.errors.clientGroup}

                                                            >
                                                                <MenuItem key={0} value={'Empresas del Estado'}>Empresas del Estado</MenuItem>
                                                                <MenuItem key={1} value={'subsidiado'}>Subsidiado</MenuItem>
                                                            </TextField> */}



                                    <Row>
                                        <Col md={3}>
                                            <TextField
                                                label="País"
                                                id="id-simplepais-select"
                                                className="material-form__field"
                                                style={{ marginLeft: 20 }}
                                                select
                                                value={this.state.country}
                                                onChange={(event) => {
                                                    this.handleCountry(event.target.value);
                                                }}
                                                error={this.state.errors.hasOwnProperty("country") ? this.state.errors.country !== "" : false}
                                                helperText={this.state.errors.country}
                                                InputLabelProps={{
                                                    style: { color: '#646777' },
                                                    shrink: true
                                                }}

                                            >
                                                {this.state.countries.map((country) => {
                                                    return <MenuItem key={country.id} value={country.paicod}>{country.painom}</MenuItem>
                                                })}
                                          </TextField>
                                        </Col>
                                        <Col md={3}>
                                            <TextField
                                                label="Departamento"
                                                id="id-simpledep-select"
                                                className="material-form__field"
                                                style={{ marginLeft: 20 }}
                                                select
                                                value={this.state.department}
                                                onChange={(event) => {
                                                    //console.log(event.target.value);
                                                    this.handleDepartment(event.target.value);
                                                }}
                                                error={this.state.errors.hasOwnProperty("department") ? this.state.errors.department !== "" : false}
                                                helperText={this.state.errors.department}
                                                InputLabelProps={{
                                                    style: { color: '#646777' },
                                                    shrink: true
                                                }}
                                            >
                                                {this.state.departments.length ?
                                                    this.state.departments.map((department) => {
                                                        return <MenuItem key={department.id} value={department.depcod}>{department.depnom}</MenuItem>
                                                    })
                                                :
                                                    <MenuItem value="">No hay departamentos</MenuItem>
                                                }
                                            </TextField>
                                        </Col>
                                        <Col md={3}>
                                            <TextField
                                                className="material-form__field"
                                                label="Ciudad"
                                                id="id-simplecity-select"
                                                style={{ marginLeft: 20 }}
                                                select
                                                value={this.state.city}
                                                onChange={(event) => {
                                                    this.handleCity(event.target.value);
                                                }}
                                                error={this.state.errors.hasOwnProperty("city") ? this.state.errors.city !== "" : false}
                                                helperText={this.state.errors.city}
                                                InputLabelProps={{
                                                    style: { color: '#646777' },
                                                    shrink: true
                                                }}
                                            >
                                                {this.state.cities.length ?
                                                    this.state.cities.map((city) => {
                                                        return <MenuItem key={city.id} value={city.ciucod} name={city.ciunom}>{city.ciunom}</MenuItem>
                                                    })
                                                :
                                                    <MenuItem value="">No hay ciudades</MenuItem>
                                                }

                                            </TextField>
                                        </Col>
                                    </Row>


                                    <Row>
                                        <Col md={3}>
                                            <TextField
                                                required
                                                id="address-standard-required"
                                                label="Dirección"
                                                type="text"
                                                className="material-form__field"
                                                style={{ marginLeft: 20 }}
                                                value={this.state.address}
                                                onChange={(e) => {
                                                    this.handleAddress(e.target.value);
                                                }}
                                                error={this.state.errors.hasOwnProperty("address") ? this.state.errors.address !== "" : false}
                                                helperText={this.state.errors.address}
                                                InputLabelProps={{
                                                    style: { color: '#646777' },
                                                    shrink: true
                                                }}
                                            />
                                        </Col>
                                        <Col md={3}>
                                            <TextField
                                                required
                                                id="email-standard-required"
                                                label="Correo electrónico"
                                                type="email"
                                                className="material-form__field"
                                                style={{ marginLeft: 20 }}
                                                value={this.state.email}
                                                onChange={(e) => {
                                                    this.handleEmail(e.target.value);
                                                }}
                                                error={this.state.errors.hasOwnProperty("email") ? this.state.errors.email !== "" : false}
                                                helperText={this.state.errors.email}
                                                InputLabelProps={{
                                                    style: { color: '#646777' },
                                                    shrink: true
                                                }}
                                            />
                                        </Col>
                                        <Col md={3}>
                                            <TextField
                                                id="web-standard"
                                                label="Pagina Web"
                                                type="text"
                                                className="material-form__field"
                                                style={{ marginLeft: 20 }}
                                                value={this.state.webSite}
                                                onChange={(e) => {
                                                    this.handleWebSite(e.target.value);
                                                }}
                                                error={this.state.errors.hasOwnProperty("email") ? this.state.errors.webSite !== "" : false}
                                                helperText={this.state.errors.webSite}
                                                InputLabelProps={{
                                                    style: { color: '#646777' },
                                                    shrink: true
                                                }}
                                            />
                                        </Col>
                                    </Row>

                                    <Row>
                                        <Col md={3}>
                                            <TextField
                                                required
                                                id="email-standard-required"
                                                label="Resolución supersalud"
                                                type="text"
                                                className="material-form__field"
                                                style={{ marginLeft: 20 }}
                                                value={this.state.resolution}
                                                onChange={(e) => {
                                                    this.handleResolution(e.target.value);
                                                }}
                                                error={this.state.errors.hasOwnProperty("resolution") ? this.state.errors.resolution !== "" : false}
                                                helperText={this.state.errors.resolution}
                                                InputLabelProps={{
                                                    style: { color: '#646777' },
                                                    shrink: true
                                                }}
                                            />
                                        </Col>
                                        <Col md={3}>
                                            <TextField
                                                required
                                                id="email-standard-required"
                                                label="Codigo SGSSS"
                                                type="text"
                                                className="material-form__field"
                                                style={{ marginLeft: 20 }}
                                                value={this.state.sgss}
                                                onChange={(e) => {
                                                    this.handleSGSS(e.target.value);
                                                }}
                                                error={this.state.errors.hasOwnProperty("sgss") ? this.state.errors.sgss !== "" : false}
                                                helperText={this.state.errors.sgss}
                                                InputLabelProps={{
                                                    style: { color: '#646777' },
                                                    shrink: true
                                                }}
                                            />
                                        </Col>
                                        <Col md={3}>
                                            <TextField
                                                label="Tipo de Cliente"
                                                id="id-simpletercero-select"
                                                className="material-form__field"
                                                style={{ marginLeft: 20 }}
                                                select
                                                value={this.state.tipo}
                                                onChange={(event) => {
                                                    this.handleChangeTipo(event.target.value);
                                                }}
                                                error={this.state.errors.hasOwnProperty("tipo") ? this.state.errors.tipo !== "" : false}
                                                helperText={this.state.errors.tipo}
                                                InputLabelProps={{
                                                    style: { color: '#646777' },
                                                    shrink: true
                                                }}
                                            >
                                                <MenuItem key={1} value={1}>Cliente</MenuItem>
                                                <MenuItem key={2} value={2}>Patrocinador</MenuItem>
                                                <MenuItem key={3} value={3}>CRO</MenuItem>
                                                <MenuItem key={4} value={4}>Particular</MenuItem>
                                            </TextField>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col md={3}>
                                            <TextField
                                                label="Tipo de Responsabilidad"
                                                id="id-simpletercero-select"
                                                className="material-form__field"
                                                style={{ marginLeft: 20 }}
                                                select
                                                value={this.state.responsabilityType}
                                                onChange={(event) => {
                                                    this.handlerResponsabilityType(event.target.value);
                                                }}
                                                error={this.state.errors.hasOwnProperty("responsabilityType") ? this.state.errors.responsabilityType !== "" : false}
                                                helperText={this.state.errors.responsabilityType}
                                                InputLabelProps={{
                                                    style: { color: '#646777' },
                                                    shrink: true
                                                }}
                                            >
                                                <MenuItem key={1} value={1}>O-13 - GRAN CONTRIBUYENTE </MenuItem>
                                                <MenuItem key={2} value={2}>O-15 - AUTORRETENEDOR </MenuItem>
                                                <MenuItem key={3} value={3}>O-23 - AGENTE DE RETENCIÓN IVA </MenuItem>
                                                <MenuItem key={4} value={4}>O-47 - RÉGIMEN SIMPLE DE TRIBUTACIÓN </MenuItem>
                                                <MenuItem key={5} value={5}>R-99-PN - NO RESPONSABLE (NO RESPONSABLE DE IVA) </MenuItem>
                                            </TextField>
                                        </Col>
                                        <Col md={3}>
                                            <TextField
                                                label="Responsabilidad Tributaria"
                                                id="id-simpletercero-select"
                                                className="material-form__field"
                                                style={{ marginLeft: 20 }}
                                                select
                                                value={this.state.tributaryResponsability}
                                                onChange={(event) => {
                                                    this.handlerTributaryResponsability(event.target.value);
                                                }}
                                                error={this.state.errors.hasOwnProperty("tributaryResponsability") ? this.state.errors.tributaryResponsability !== "" : false}
                                                helperText={this.state.errors.tributaryResponsability}
                                                InputLabelProps={{
                                                    style: { color: '#646777' },
                                                    shrink: true
                                                }}
                                            >
                                                <MenuItem key={1} value={1}>IVA </MenuItem>
                                                <MenuItem key={2} value={2}>INC </MenuItem>
                                                <MenuItem key={3} value={3}>IVA e INC </MenuItem>
                                                <MenuItem key={4} value={4}>No Aplica </MenuItem>
                                            </TextField>
                                        </Col>
                                        <Col md={3}>
                                            <TextField
                                                label="Tipo de Contribuyente"
                                                id="id-simpletercero-select"
                                                className="material-form__field"
                                                style={{ marginLeft: 20 }}
                                                select
                                                value={this.state.taxpayerType}
                                                onChange={(event) => {
                                                    this.handlerTaxpayerType(event.target.value);
                                                }}
                                                error={this.state.errors.hasOwnProperty("taxpayerType") ? this.state.errors.taxpayerType !== "" : false}
                                                helperText={this.state.errors.taxpayerType}
                                                InputLabelProps={{
                                                    style: { color: '#646777' },
                                                    shrink: true
                                                }}
                                            >
                                                <MenuItem key={1} value={1}>PERSONA NATURAL </MenuItem>
                                                <MenuItem key={2} value={2}>PERSONA JURIDICA </MenuItem>
                                            </TextField>
                                        </Col>
                                    </Row>

                                    <Row>
                                        <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-start' }}>
                                            <FormControlLabel
                                                style={{ marginLeft: 20 }}
                                                id={"chkxTarjetaDescuento_FormLabel"}
                                                value={this.state.discountCard}
                                                control={
                                                    <MedicalCheckbox
                                                        id={"chkxTarjetaDescuento"}
                                                        checked={this.state.discountCard}

                                                        onChange={(event, check) => {
                                                            this.handleChangeDiscountCard(check)
                                                        }}
                                                        iconStyle={{ fill: 'green' }}
                                                    />
                                                }
                                                label={"Tarjeta de Descuento"}
                                                labelPlacement={"Tarjeta de Descuento"}
                                            />
                                            <FormControlLabel
                                                style={{ marginLeft: 20 }}
                                                id={"chkxAutomaticReceipts_FormLabel"}
                                                value={this.state.automaticReceiptInZero}
                                                control={
                                                    <MedicalCheckbox
                                                        id={"chkxAutomaticReceipts"}
                                                        checked={this.state.automaticReceiptInZero}
                                                        onChange={(event, check) => {
                                                            this.handlerAutoReceiptsZero(check)
                                                        }}
                                                        iconStyle={{ fill: 'green' }}
                                                    />
                                                }
                                                label={"Crear recibos en 0 al momento de admitir"}
                                                labelPlacement={"Crear recibos en 0 al momento de admitir"}
                                            />
                                        </div>
                                    </Row>

                                    <Row>
                                        <Col md={3}>
                                            <TextField
                                                multiline
                                                maxRows={3}
                                                id="observaciones"
                                                label="Observaciones"
                                                type="text"
                                                className="material-form__field"
                                                style={{ marginTop: 20, marginLeft: 20 }}
                                                value={this.state.observaciones}
                                                onChange={(e) => {
                                                    this.handlerObservaciones(e.target.value);
                                                }}
                                                error={this.state.errors.hasOwnProperty("observaciones") ? this.state.errors.observaciones !== "" : false}
                                                helperText={this.state.errors.observaciones}
                                                InputLabelProps={{
                                                    style: { color: '#646777' },
                                                    shrink: true,
                                                    margin: '25ch'
                                                }}
                                            />
                                        </Col>
                                        <Col md={6}>
                                            <TextField
                                                multiline
                                                maxRows={3}
                                                id="invoice_note"
                                                label="Nota de Factura"
                                                type="text"
                                                className="material-form__field"
                                                style={{ marginTop: 20, marginLeft: 20 }}
                                                value={this.state.invoiceNote}
                                                onChange={(e) => {
                                                    this.handlerinvoiceNote(e.target.value);
                                                }}
                                                error={this.state.errors.hasOwnProperty("invoiceNote") ? this.state.errors.invoiceNote !== "" : false}
                                                helperText={this.state.errors.invoiceNote}
                                                InputLabelProps={{
                                                    style: { color: '#646777' },
                                                    shrink: true,
                                                    margin: '25ch'
                                                }}
                                            />
                                        </Col>

                                    </Row>
                                    {/* <TextField
                                                        required
                                                        id="email-standard-required"
                                                        label="Días de vencimiento"
                                                        type="text"
                                                        className="material-form__field"
                                                        style={{ width: '20%', marginTop: 20 }}
                                                        value={this.state.days}
                                                        onChange={(e) => {
                                                            this.handleDaysDeadLine(e.target.value);
                                                        }}
                                                        error={this.state.errors.hasOwnProperty("days") ? this.state.errors.days !== "" : false}
                                                        helperText={this.state.errors.days}
                                                    />

                                                    <FormControl component="fieldset" style={{ marginLeft: 20, marginTop: 20 }} >
                                                        <FormLabel className="material-form__field" component="legend">Cliente particular</FormLabel>
                                                        <RadioGroup
                                                            aria-label="particular"
                                                            name="particular"
                                                            style={{ flex: 1, flexDirection: 'row' }}
                                                            value={this.state.particular}
                                                            onChange={e => { this.handleParticular(e.target.value) }}
                                                        >
                                                            <FormControlLabel value="Si" control={<Radio className="radio-btn" color="primary" disabled={false} />} label="SI" />
                                                            <FormControlLabel value="No" control={<Radio className="radio-btn" color="primary" disabled={false} />} label="NO" />

                                                        </RadioGroup>
                                                    </FormControl>

                                                    <FormControl component="fieldset" style={{ marginLeft: 20, marginTop: 20 }} >
                                                        <FormLabel className="material-form__field" component="legend">Copia de historial Clinico</FormLabel>
                                                        <RadioGroup
                                                            aria-label="history"
                                                            name="history"
                                                            style={{ flex: 1, flexDirection: 'row' }}
                                                            value={this.state.history}
                                                            onChange={e => {
                                                                this.handleHistory(e.target.value);
                                                            }}
                                                        >
                                                            <FormControlLabel value="Si" control={<Radio className="radio-btn" color="primary" disabled={false} />} label="SI" />
                                                            <FormControlLabel value="No" control={<Radio className="radio-btn" color="primary" disabled={false} />} label="NO" />
                                                        </RadioGroup>
                                                    </FormControl> */}


                                    <Button
                                        style={{ marginTop: 20 }}
                                        color="primary"
                                        onClick={() => {
                                            if (this.state.isPropsFromLocation) {
                                                if (this.props.location.state.update)
                                                    this.updateThird();
                                                else {
                                                    this.createThird();
                                                }
                                            } else {
                                                if (this.props.update)
                                                    this.updateThird();
                                                else {
                                                    this.createThird();
                                                }
                                            }

                                        }}
                                    >
                                        {this.props.hasOwnProperty('location') ?
                                            this.props.location.state.update ? "Actualizar Cliente" : "Crear Cliente"
                                            : this.props.update ? "Actualizar Cliente" : "Crear Cliente"
                                        }
                                    </Button>
                                    {this.state.openAlert ?
                                        <Modal
                                            color={this.state.color}
                                            title=""
                                            message={this.state.message}
                                            modal={this.state.openAlert}
                                            onOk={() => {
                                                console.log(this.state.error);
                                                if (this.state.isPropsFromLocation) {
                                                    if (this.state.error) {
                                                        this.setState({ openAlert: !this.state.openAlert })
                                                    } else {
                                                        history.push({
                                                            pathname: process.env.PUBLIC_URL + '/config/terceros/listar'
                                                        });
                                                    }
                                                } else {
                                                    if (this.state.error) {
                                                        this.setState({ openAlert: !this.state.openAlert })
                                                    } else {
                                                        this.props.setEditThird(false)
                                                    }
                                                }
                                            }}
                                            toggle={() => { this.setState({ openAlert: !this.state.openAlert }) }}
                                        /> : null}
                                </form>

                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Container>)
    }
}

export default reduxForm({
    form: 'third_party_Updateform', // a unique identifier for this form
})(withTranslation('common')(ThirdPartyUpdate));
